import styled from "styled-components";

const FadeBackground = styled.div`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10000;
    left: 0;
    top: 0;
    background-color: #32323233;
`;

const StyledMessageBox = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    width: 250px;
    height: 150px;
    border-radius: 5px;
    margin: auto;
    font-size: 12px;
    font-weight: 600;
    border: solid 1px ${(props) => props.isWarning === true ? '#DB0640' : props.theme.color.primaryblue};
    z-index: 9999;
`;

const MessageText = styled.span`
    display: block;
    width: 200px;
    color: ${(props) => props.isWarning === true ? '#DB0640' : props.theme.color.primaryblue};
    text-align: center;
    user-select: none;
    margin: auto auto 0 auto;
`;

const Buttons = styled.div`
    display: flex;
    width: 100%;
    height: 55px;
    margin-top: auto;
`;

const YesButton = styled.button`
    height: 35px;
    background-color: ${(props) => props.isWarning === true ? '#DB0640' : props.theme.color.primaryblue};
    color: white;
    font-size: 12px;
    font-weight: 600;
    border: solid 1px ${(props) => props.isWarning === true ? '#DB0640' : props.theme.color.primaryblue};
    min-width: 75px;
    margin: 0 auto;
    padding-left: 12px;
    padding-right: 12px;
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    cursor: pointer;
    padding-bottom: 4px;
    user-select: none;
    border-radius: 2px;

    &:hover:enabled {
        background-color: ${(props) => props.isWarning === true ? '#FF2B64' : props.theme.color.primaryhover};
    }
    :active:enabled {
        border:1px solid ${(props) => props.isWarning === true ? '#FF2B64' : props.theme.color.primaryhover};
        box-shadow: 0 0 3px ${(props) => props.isWarning === true ? '#FF2B64' : props.theme.color.primaryhover};
    }
    :disabled {
        color: ${(props) => props.theme.color.gray};
        background-color: ${(props) => props.theme.color.disabledgray}
    }
`;

const CancelButton = styled.button`
    width: 75px;
    height: 35px;
    background-color: white;
    margin-left: auto;
    color: ${(props) => props.theme.color.gray};
    font-size: 12px;
    font-weight: 600;
    border: solid 1px ${(props) => props.theme.color.gray};
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    cursor: pointer;
    padding-bottom: 4px;
    user-select: none;
    border-radius: 2px;

    &:hover:enabled {
        background-color: ${(props) => props.theme.color.lightgray};
    }
    :active:enabled {
        box-shadow: 0 0 3px ${(props) => props.theme.color.disabledgray};
    }
    :disabled {
        color: ${(props) => props.theme.color.gray};
        background-color: ${(props) => props.theme.color.disabledgray}
    }
`;

function MessageBox(props) {

    const handleClickFadeBackground = (e) => {
        if (props.handleClickNo) {
            props.handleClickNo();
        }
        e.stopPropagation();
        e.preventDefault();
    }

    return (
        <FadeBackground onClick={handleClickFadeBackground}>
            <StyledMessageBox onClick={(e) => {e.stopPropagation(); e.preventDefault()}} {...props}>
                <MessageText {...props}>{props.text}</MessageText>
            <Buttons>
                <CancelButton onClick={(e) => props.handleClickNo()}>{props.noText ? props.noText : 'Cancel'}</CancelButton>
                <YesButton onClick={(e) => props.handleClickYes()} isWarning={props.isWarning}>{props.yesText}</YesButton>
            </Buttons>
            </StyledMessageBox>
        </FadeBackground>
    );
}

export default MessageBox;